import React from 'react';
import { Search, SortAsc, Star } from 'lucide-react';

export default function SearchBar({ 
  searchTerm, 
  setSearchTerm, 
  placeholder = "Search...", 
  sortAlphabetically = false, 
  setSortAlphabetically,
  onStarAllVisible = null,
  visibleMoviesCount = 0,
  showStarAllButton = false
}) {
  return (
    <div className="flex items-center space-x-4 mb-6">
      {/* Search Input */}
      <div className="flex-1 relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Search className="h-4 w-4 text-orange-400" />
        </div>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={placeholder}
          className="w-full bg-gray-700 border-2 border-orange-600 text-orange-100 rounded-md pl-10 pr-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
        />
      </div>

      {/* Star All Button */}
      {showStarAllButton && onStarAllVisible && visibleMoviesCount > 0 && (
        <button
          onClick={onStarAllVisible}
          className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-md font-medium hover:bg-purple-500 transition-colors"
          title={`Star all ${visibleMoviesCount} movies on this page`}
        >
          <Star size={16} />
          <span className="hidden sm:inline">Star All on Page ({visibleMoviesCount})</span>
          <span className="sm:hidden">Star Page</span>
        </button>
      )}

      {/* Sort Toggle */}
      {setSortAlphabetically && (
        <button
          onClick={() => setSortAlphabetically(!sortAlphabetically)}
          className={`flex items-center space-x-2 px-4 py-2 rounded-md font-medium transition-colors ${
            sortAlphabetically
              ? 'bg-orange-600 text-white hover:bg-orange-500'
              : 'bg-gray-700 text-orange-300 border-2 border-orange-600 hover:bg-gray-600'
          }`}
        >
          <SortAsc size={16} />
          <span className="hidden sm:inline">Sort A-Z</span>
        </button>
      )}
    </div>
  );
}
